// GENERATED from registry/exotics.yaml by scripts/gen_exotics_js.py. Do not edit.
//
// `python3 scripts/gen_exotics_js.py --check` fails CI if this file and the YAML disagree, so an
// edit here is an edit that will be reverted. Change the YAML.
//
// Every row is a fact sheet with the page its numbers were read from; the generator turned the
// source's hours-minutes-seconds into degrees and a range into low/high/mid. data/layers.js turns
// these into `static` records on the sun-inertial axes.

/** Black holes and other extremes, one fact sheet each, with the source it was read from. */
export const EXOTICS = [
  {
    "id": "sgr-a-star",
    "name": "Sagittarius A*",
    "kind": "blackhole",
    "why": "The black hole at the centre of our galaxy, four million Suns in one point. Every star on this map goes round it.",
    "aliases": [
      "Sgr A*",
      "galactic centre black hole"
    ],
    "source": "https://en.wikipedia.org/wiki/Sagittarius_A* (infobox, read 2026-09-08)",
    "image": {
      "file": "site/images/eht-sgr-a.jpg",
      "credit": "EHT Collaboration",
      "licence": "CC BY 4.0",
      "source": "https://www.eso.org/public/images/eso2208-eht-mwa/ -- Screensize JPEG, 1280x1280, downloaded 2026-09-17",
      "alt": "A thick orange ring of light with three brighter knots, around a dark centre."
    },
    "raDeg": 266.416837,
    "decDeg": -29.007811,
    "distLy": 26996,
    "massMsun": 4297000
  },
  {
    "id": "m87-star",
    "name": "M87*",
    "kind": "blackhole",
    "why": "The first black hole anyone photographed: the orange ring of 2019. Six and a half billion Suns, at the heart of the galaxy M87.",
    "aliases": [
      "Powehi",
      "Virgo A black hole"
    ],
    "source": "https://en.wikipedia.org/wiki/Messier_87 (infobox and the M87* section; EHT 2019 mass, read 2026-09-08)",
    "image": {
      "file": "site/images/eht-m87.jpg",
      "credit": "EHT Collaboration",
      "licence": "CC BY 4.0",
      "source": "https://www.eso.org/public/images/eso1907a/ -- Screensize JPEG, 1280x746, downloaded 2026-09-17",
      "alt": "A fuzzy orange ring of light around a dark centre, brighter along the bottom."
    },
    "raDeg": 187.705931,
    "decDeg": 12.391123,
    "distLy": 53500000,
    "massMsun": 6500000000
  },
  {
    "id": "cygnus-x-1",
    "name": "Cygnus X-1",
    "kind": "blackhole",
    "why": "The first black hole anyone was sure of, found in 1964 by its X-rays. It is eating a blue supergiant, HDE 226868.",
    "aliases": [
      "Cyg X-1"
    ],
    "source": "https://en.wikipedia.org/wiki/Cygnus_X-1 (infobox, read 2026-09-08)",
    "raDeg": 299.590316,
    "decDeg": 35.201607,
    "distLy": 7300,
    "massMsunLow": 13.8,
    "massMsunHigh": 17.5,
    "massMsun": 15.65
  },
  {
    "id": "gaia-bh1",
    "name": "Gaia BH1",
    "kind": "blackhole",
    "why": "The nearest known black hole, found in 2022 by the wobble of the Sun-like star that orbits it. It is quiet: nothing falls in.",
    "source": "https://en.wikipedia.org/wiki/Gaia_BH1 (infobox, read 2026-09-08)",
    "raDeg": 262.171236,
    "decDeg": -0.580979,
    "distLy": 1560,
    "massMsun": 9.27
  },
  {
    "id": "gaia-bh3",
    "name": "Gaia BH3",
    "kind": "blackhole",
    "why": "The heaviest black hole from a dead star in our galaxy, thirty-three Suns, found in 2024 in the Gaia data.",
    "source": "https://en.wikipedia.org/wiki/Gaia_BH3 (infobox, read 2026-09-08)",
    "raDeg": 294.827958,
    "decDeg": 14.931667,
    "distLy": 1936,
    "massMsun": 33.08
  },
  {
    "id": "v404-cygni",
    "name": "V404 Cygni",
    "kind": "blackhole",
    "why": "A black hole that flares: in 2015 it lit up brighter than anything else in the X-ray sky for two weeks, then went quiet again.",
    "source": "https://en.wikipedia.org/wiki/V404_Cygni (infobox, read 2026-09-08)",
    "raDeg": 306.015917,
    "decDeg": 33.867222,
    "distLy": 7800,
    "massMsun": 9
  },
  {
    "id": "ton-618",
    "name": "TON 618",
    "kind": "blackhole",
    "why": "One of the heaviest black holes known, forty billion Suns, so far away that its light left before the Earth existed.",
    "source": "https://en.wikipedia.org/wiki/TON_618 (infobox; 2019 mass estimate, read 2026-09-08)",
    "distance_note": "how far it is now (comoving distance), from its redshift of 2.219 in the Planck 2018 cosmology. Its light-travel time is 10.8 billion years: we see it as it was when the universe was 3 billion years old, not as it is",
    "redshift": 2.219,
    "raDeg": 187.10375,
    "decDeg": 31.477222,
    "distLy": 18300000000,
    "massMsun": 40700000000
  },
  {
    "id": "crab-pulsar",
    "name": "Crab Pulsar",
    "kind": "pulsar",
    "why": "What was left when a star seen exploding in 1054 collapsed: a city-sized star spinning thirty times a second, inside the Crab Nebula (M1).",
    "aliases": [
      "PSR B0531+21"
    ],
    "source": "https://en.wikipedia.org/wiki/Crab_Pulsar (infobox, read 2026-09-08)",
    "raDeg": 83.633125,
    "decDeg": 22.0145,
    "distLy": 6200,
    "periodS": 0.0333924123
  },
  {
    "id": "vela-pulsar",
    "name": "Vela Pulsar",
    "kind": "pulsar",
    "why": "The brightest pulsar in the gamma-ray sky, eleven times a second, from a supernova about eleven thousand years ago.",
    "aliases": [
      "PSR B0833-45"
    ],
    "source": "https://en.wikipedia.org/wiki/Vela_Pulsar (infobox, read 2026-09-08)",
    "raDeg": 128.836064,
    "decDeg": -45.176432,
    "distLy": 959,
    "periodS": 0.089328385024
  },
  {
    "id": "psr-b1919-21",
    "name": "PSR B1919+21",
    "kind": "pulsar",
    "why": "The first pulsar ever found, by Jocelyn Bell Burnell in 1967. Its tick was so regular it was nicknamed LGM-1: Little Green Men.",
    "aliases": [
      "LGM-1",
      "CP 1919"
    ],
    "source": "https://en.wikipedia.org/wiki/PSR_B1919%2B21 (infobox, read 2026-09-08)",
    "raDeg": 290.436729,
    "decDeg": 21.883958,
    "distLyLow": 300,
    "distLyHigh": 3600,
    "distLy": 1950.0,
    "periodS": 1.3373021601895
  },
  {
    "id": "sgr-1806-20",
    "name": "SGR 1806-20",
    "kind": "magnetar",
    "why": "A magnetar: a neutron star with the strongest magnetic field known. Its flare of 27 December 2004 was the brightest event ever seen from outside the Solar System, and it briefly stretched Earth's ionosphere.",
    "aliases": [
      "SGR 1806−20",
      "GRB 790107"
    ],
    "source": "https://en.wikipedia.org/wiki/SGR_1806%E2%88%9220 (infobox, read 2026-09-08)",
    "raDeg": 272.163833,
    "decDeg": -20.410972,
    "distLy": 42000,
    "periodS": 7.55592
  },
  {
    "id": "geminga",
    "name": "Geminga",
    "kind": "pulsar",
    "why": "A pulsar found by its gamma rays alone, in 1972, and unidentified for twenty years. Its name is Milanese for 'it is not there'.",
    "aliases": [
      "PSR B0633+17",
      "PSR J0633+1746"
    ],
    "source": "https://en.wikipedia.org/wiki/Geminga (infobox, read 2026-09-08)",
    "distance_note": "about 815 light-years; the parallax has a wide error bar (250 +120/-62 parsecs)",
    "vmag": 25.5,
    "raDeg": 98.475625,
    "decDeg": 17.77025,
    "distLy": 815,
    "periodS": 0.237
  },
  {
    "id": "eta-carinae",
    "name": "Eta Carinae",
    "kind": "star",
    "why": "A star of about a hundred Suns that erupted in the 1840s, briefly the second brightest in the sky, and wrapped itself in the Homunculus Nebula. A supernova waiting to happen.",
    "aliases": [
      "η Carinae",
      "η Car",
      "Eta Car"
    ],
    "source": "https://en.wikipedia.org/wiki/Eta_Carinae (infobox: mass ~100 Suns, read 2026-09-08); the distance, 2 350 +/- 50 pc, is the Homunculus's expansion parallax (Smith 2006, ApJ 644, 1151), with which Gaia agrees (Göppl & Preibisch 2022, A&A 660, A11)",
    "vmag": 4.2,
    "raDeg": 161.264962,
    "decDeg": -59.684517,
    "distLy": 7665,
    "massMsun": 100
  },
  {
    "id": "wd-j1330-6435",
    "name": "WD J1330+6435",
    "kind": "star",
    "why": "The first star found that would look green, in its discoverers' colour models: a cool white dwarf whose sodium-rich atmosphere absorbs yellow, orange and red light. A star this cool would otherwise look orange.",
    "aliases": [
      "SDSS J1330+6435",
      "WD 1328+648"
    ],
    "source": "https://en.wikipedia.org/wiki/WD_J1330%2B6435 (infobox: distance 281.6 ly / 86.35 pc from parallax, Gaia G mag 20.64, Gaia DR3 position, read 2026-10-19); https://warwick.ac.uk/news/pressreleases/astronomers-reveal-true-colours-of-white-dwarf-stars (University of Warwick, 15 October 2026: about 4 000 degrees C, colour calculated from its spectrum by a model of human colour vision, sodium absorbs yellow, orange and red; Hollands et al., RAS Techniques and Instruments, doi 10.1093/rasti/rzag069, read 2026-10-20); https://www.space.com/astronomy/stars/astronomers-discover-the-1st-ever-green-star-a-cosmic-zombie-just-in-time-for-halloween (read 2026-10-19)",
    "vmag": 20.6,
    "raDeg": 202.50485,
    "decDeg": 64.589919,
    "distLy": 281.6
  },
  {
    "id": "betelgeuse",
    "name": "Betelgeuse",
    "kind": "star",
    "why": "The red shoulder of Orion, a supergiant so large it would swallow Mars. It dimmed in 2019-20 after coughing out a cloud of dust; one day it will go supernova.",
    "aliases": [
      "α Orionis",
      "Alpha Orionis",
      "α Ori"
    ],
    "source": "https://en.wikipedia.org/wiki/Betelgeuse (infobox, read 2026-09-08)",
    "distance_note": "two published distances, 408 and 548 light-years; the star's boiling surface makes its parallax hard to pin down",
    "vmag": 0.5,
    "raDeg": 88.792939,
    "decDeg": 7.407064,
    "distLyLow": 408,
    "distLyHigh": 548,
    "distLy": 478.0,
    "massMsun": 14
  },
  {
    "id": "ss-433",
    "name": "SS 433",
    "kind": "blackhole",
    "why": "The first microquasar: a black hole in a binary firing two jets at a quarter of the speed of light, which wobble round once every 162 days.",
    "aliases": [
      "V1343 Aquilae",
      "SS433"
    ],
    "source": "https://en.wikipedia.org/wiki/SS_433 (infobox, read 2026-09-09)",
    "distance_note": "18 000 +/- 700 light-years (5 500 +/- 200 parsecs)",
    "raDeg": 287.9565,
    "decDeg": 4.982722,
    "distLy": 18000,
    "massMsun": 10.9
  },
  {
    "id": "grs-1915-105",
    "name": "GRS 1915+105",
    "kind": "blackhole",
    "why": "For years the heaviest stellar black hole known in our galaxy, and the first thing in it seen throwing out matter apparently faster than light: a trick of geometry called superluminal motion.",
    "aliases": [
      "V1487 Aquilae"
    ],
    "source": "https://en.wikipedia.org/wiki/GRS_1915%2B105 (infobox, read 2026-09-09)",
    "distance_note": "8 600 +2 000/-1 600 parsecs; 28 000 light-years is the infobox's round figure",
    "raDeg": 288.798333,
    "decDeg": 10.945556,
    "distLy": 28000,
    "massMsun": 12.4
  },
  {
    "id": "psr-j1748-2446ad",
    "name": "PSR J1748-2446ad",
    "kind": "pulsar",
    "why": "The fastest-spinning pulsar known: 716 turns a second, its equator moving at a quarter of the speed of light, inside the globular cluster Terzan 5.",
    "aliases": [
      "Terzan 5ad",
      "fastest pulsar"
    ],
    "source": "https://en.wikipedia.org/wiki/PSR_J1748%E2%88%922446ad (infobox, read 2026-09-09)",
    "raDeg": 267.020417,
    "decDeg": -24.767778,
    "distLy": 18000,
    "periodS": 0.00139595482
  },
  {
    "id": "hulse-taylor",
    "name": "Hulse-Taylor pulsar",
    "kind": "pulsar",
    "why": "Two neutron stars circling each other every 7.75 hours, spiralling inward exactly as Einstein's gravitational waves demand. It won the 1993 Nobel Prize, twenty-two years before the waves were heard directly.",
    "aliases": [
      "PSR B1913+16",
      "PSR J1915+1606"
    ],
    "source": "https://en.wikipedia.org/wiki/Hulse%E2%80%93Taylor_pulsar (infobox, read 2026-09-09)",
    "raDeg": 288.30194,
    "decDeg": 16.018941,
    "distLy": 21000,
    "massMsun": 1.441,
    "periodS": 0.059030003217813
  },
  {
    "id": "psr-j1614-2230",
    "name": "PSR J1614-2230",
    "kind": "pulsar",
    "why": "A neutron star of nearly two Suns, weighed in 2010 by the delay its companion's gravity puts on its radio ticks, a mass that ruled out many ideas of what neutron stars are made of.",
    "aliases": [
      "J1614-2230"
    ],
    "source": "https://en.wikipedia.org/wiki/PSR_J1614%E2%88%922230 (infobox, read 2026-09-09)",
    "raDeg": 243.652105,
    "decDeg": -22.508634,
    "distLy": 3900,
    "massMsun": 1.908,
    "periodS": 0.003150807655690673
  },
  {
    "id": "psr-j0348-0432",
    "name": "PSR J0348+0432",
    "kind": "pulsar",
    "why": "Two Suns in a ball twenty kilometres across, circling a white dwarf every two and a half hours; among the heaviest neutron stars ever weighed.",
    "aliases": [
      "J0348+0432"
    ],
    "source": "https://en.wikipedia.org/wiki/PSR_J0348%2B0432 (infobox, read 2026-09-09)",
    "raDeg": 57.181829,
    "decDeg": 4.536517,
    "distLy": 6800,
    "massMsun": 2.01,
    "periodS": 0.0391226563571297
  },
  {
    "id": "3c-273",
    "name": "3C 273",
    "kind": "quasar",
    "why": "The first quasar ever identified and the brightest in our sky: a black hole of nearly a billion Suns eating gas, outshining the whole giant galaxy around it sixteen times over.",
    "aliases": [
      "3C273",
      "PGC 41121"
    ],
    "source": "https://en.wikipedia.org/wiki/3C_273 (infobox: position, redshift 0.158339 and apparent magnitude 12.9 from NED, mass 886 million Suns; the host galaxy, an E4 of apparent size 29 arcseconds and magnitude 16 after Bahcall and others 1997, ApJ 479, 642; read 2026-10-20)",
    "distance_note": "how far it is now (comoving distance), from its redshift of 0.158339 in the Planck 2018 cosmology. Its light-travel time is 2.0 billion years: we see it as it was, not as it is. A separate method, the spectroastrometry of its gas (Wang and others, Nature Astronomy 2020), gives 1.8 billion light-years with a wide margin",
    "vmag": 12.9,
    "redshift": 0.158339,
    "raDeg": 187.277917,
    "decDeg": 2.0525,
    "distLy": 2200000000,
    "massMsun": 886000000
  },
  {
    "id": "3c-279",
    "name": "3C 279",
    "kind": "quasar",
    "why": "A quasar that flickers in visible light, radio waves and X-rays; in 1973 its jet seemed to move faster than light, an illusion that comes from the angle we see it at.",
    "aliases": [
      "3C279",
      "4C -05.55",
      "NRAO 413",
      "PKS 1253-05"
    ],
    "source": "https://en.wikipedia.org/wiki/3C_279 (infobox: position, redshift 0.5362 and magnitude 17.8 from NED; read 2026-10-20)",
    "distance_note": "how far it is now (comoving distance), from its redshift of 0.5362 in the Planck 2018 cosmology. Its light-travel time is 5.5 billion years: we see it as it was, not as it is",
    "vmag": 17.8,
    "redshift": 0.5362,
    "raDeg": 194.04625,
    "decDeg": -5.789444,
    "distLy": 6740000000
  }
];
